export default __webpack_public_path__ + "44068a5af83fafa009e78376b4ed80fb.svg";